/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Refresh: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="refresh" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1190A510 510 0 0 0 1190 680H1360L1139.5666666666666 459.5666666666667L1135.6 451.6333333333333L906.6666666666666 680H1076.6666666666665C1076.6666666666665 899.3000000000001 899.3000000000001 1076.6666666666667 680 1076.6666666666667S283.3333333333333 899.3000000000001 283.3333333333333 680S460.6999999999999 283.3333333333335 680 283.3333333333335C789.3666666666667 283.3333333333335 888.5333333333333 328.0999999999999 959.9333333333334 400.0666666666666L1040.3999999999999 319.6000000000002A507.3933333333334 507.3933333333334 0 0 0 680 170A510 510 0 0 0 680 1190z" : "M544 952A408 408 0 0 0 952 544H1088L911.6533333333334 367.6533333333333L908.48 361.3066666666666L725.3333333333334 544H861.3333333333334C861.3333333333334 719.44 719.44 861.3333333333333 544 861.3333333333333S226.6666666666667 719.44 226.6666666666667 544S368.56 226.6666666666667 544 226.6666666666667C631.4933333333333 226.6666666666667 710.8266666666667 262.4799999999999 767.9466666666667 320.0533333333333L832.32 255.68A405.9146666666668 405.9146666666668 0 0 0 544 136A408 408 0 0 0 544 952z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Refresh.displayName = `Blueprint5.Icon.Refresh`;
export default Refresh;
